import {ChevronLeft} from '@styled-icons/material/ChevronLeft';
import {ChevronRight} from '@styled-icons/material/ChevronRight';
import React from 'react';

import RightIcon from '../images/right-icon.png';
import LeftIcon from '../images/left-icon.png';

function Arrow(props) {
  const {type, onClick = () => 0} = props;

  const commonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 5,
    width: 30,
    height: 30,
    opacity: 1,
    backgroundColor: '#fff',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  };

  return type === 'prev' ? (
    <div onClick={onClick} style={{...commonStyle, left: 20}}>
      <img src={LeftIcon} width="20" />
    </div>
  ) : (
    <div onClick={onClick} style={{...commonStyle, right: 20}}>
      <img src={RightIcon} width="20" />
    </div>
  );
}

export default Arrow;
